(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-player/assets/javascripts/use-video-loader.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-player/assets/javascripts/use-video-loader.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const loadVideo = svs.components.video_player.contentLoader.loadVideo;
const updatePlaybackState = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions.updatePlaybackState;
const VIDEO_CLEAR_DELAY = 500;
const createInitialPlaybackState = () => ({
  isPlaying: false,
  isReady: false,
  currentPosition: 0,
  duration: 0
});

const useVideoLoader = (currentVideo, dispatch) => {
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    loadedVideo = _useState2[0],
    setLoadedVideo = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    hasError = _useState4[0],
    setHasError = _useState4[1];
  const currentVideoRef = useRef(currentVideo);

  useEffect(() => {
    currentVideoRef.current = currentVideo;
  }, [currentVideo]);

  const playerSettings = useMemo(() => {
    if (!(currentVideo !== null && currentVideo !== void 0 && currentVideo.id)) {
      return null;
    }
    return {
      api: true,
      publishedAt: currentVideo.publishedAt,
      thumbnail: currentVideo.thumbnailUrl,
      title: currentVideo.title,
      type: 'solidtango',
      videoId: currentVideo.id
    };
  }, [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.publishedAt, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.thumbnailUrl, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title]);

  useEffect(() => {
    let clearTimeoutId = null;
    if (!(currentVideo !== null && currentVideo !== void 0 && currentVideo.id)) {
      setHasError(false);
      dispatch(updatePlaybackState(createInitialPlaybackState()));

      setLoadedVideo(prevLoadedVideo => {
        if (prevLoadedVideo) {
          clearTimeoutId = setTimeout(() => {
            setLoadedVideo(null);
          }, VIDEO_CLEAR_DELAY);
        }
        return prevLoadedVideo; 
      });
      return () => {
        if (clearTimeoutId) {
          clearTimeout(clearTimeoutId);
        }
      };
    }
    if (!playerSettings) {
      return;
    }
    setHasError(false);
    setLoadedVideo(null);
    loadVideo(playerSettings, (err, model) => {
      var _currentVideoRef$curr;
      if (((_currentVideoRef$curr = currentVideoRef.current) === null || _currentVideoRef$curr === void 0 ? void 0 : _currentVideoRef$curr.id) === currentVideo.id) {
        if (err) {
          setHasError(true);
          return;
        }
        setLoadedVideo(model);
      }
    });
    return () => {
      if (clearTimeoutId) {
        clearTimeout(clearTimeoutId);
      }
    };
  }, [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.id, playerSettings, dispatch]);
  return {
    loadedVideo,
    hasError,
    currentVideoRef
  };
};
setGlobal('svs.components.tipsen.videoAnalysisPlayer', {
  createInitialPlaybackState,
  useVideoLoader
});

 })(window);